import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { firestore } from "../../utils/firebase";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../css/masalar.css";
import { v4 as uuid } from "uuid";
import { FaPowerOff } from "react-icons/fa";
import { FiMapPin, FiPlus, FiTrash2, FiUser } from "react-icons/fi";
import { useReactToPrint } from "react-to-print";
import { PaymentMethod } from '../../utils/items';
import { ButtonGroup, Button } from "react-bootstrap";
import { deleteCustomerAddress } from "../../services/customerRepository";
import MealOptionsMenu from "../Masalar/components/MealOptionsMenu";
import ProductCatalog from "../Masalar/components/ProductCatalog";
const Arama = ({ noSave = false }) => {
    const { number } = useParams();
    const [selected, select] = useState();
    const history = useHistory();
    const cafe = localStorage.getItem("name");
    const info = JSON.parse(localStorage.getItem("info"));
    const [menu, setMenu] = useState(null);
    const [menuObj, setMenuObj] = useState(null);
    const [posSelected, posSelect] = useState(false);
    const note = useRef();
    const nameRef = useRef();
    const addressRef = useRef();
    const notRef = useRef();
    const addressTitleRef = useRef();
    const [cart, setCart] = useState([]);
    const [user, setUser] = useState();
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [deletingAddress, setDeletingAddress] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState();
    const [paymentMethod, setPaymentMethod] = useState(PaymentMethod.Nakit);
    const priceRef = useRef();

    useEffect(() => {
        if (noSave) return;
        const id = uuid();
        firestore.collection(`Restaurants/${cafe}/aramalar`)
            .doc(id)
            .set({
                id,
                numara: number,
                tarih: new Date(),
            })

    }, [])

    useEffect(() => {
        if (number == null) return;

        firestore
            .collection(`Restaurants`)
            .doc(cafe)
            .onSnapshot((doc) => {
                let getMenu = doc.data().Menu;
                getMenu.sort((a, b) => {
                    if (a.sortOrder < b.sortOrder) return -1;
                    else return 1;
                });
                getMenu = getMenu.filter((m) => m.active == 1);
                setMenu(getMenu);
                setMenuObj(Object.assign({}, ...(getMenu.map(m => m.items.map(item => ({ [item.id]: item }))).flat())));
            });
        firestore
            .collection(`Restaurants/${cafe}/users`)
            .doc(number)
            .get()
            .then(doc => {
                if (doc.exists) {
                    setUser(doc.data());
                }
            })
    }, [number]);



    const sepeteEkle = (item) => {
        let i = 0;
        let id = uuid();
        if (cart?.length > 0) {
            let new_items = [...cart];
            let index = new_items.findIndex((el) => el == item);
            if (index != -1) {
                i = 1;
                new_items[index].quantity += parseInt(note.current.value) || 1;
                new_items[index].total += parseFloat(item.paketPrice ?? item.price) + getOptionsPrice();
                setCart(new_items);
            }
            if (i == 0)
                setCart([
                    ...cart,
                    {
                        id,
                        quantity: parseInt(note.current.value) || 1,
                        meal: item.id,
                        mealNote: "",
                        checkedOptions,
                        removedOptions,
                        optPrice: getOptionsPrice(),
                        portion: portion || null,
                        total: parseFloat(item.paketPrice ?? item.price),
                    },
                ]);
        } else {
            setCart([
                {
                    id,
                    quantity: parseInt(note.current.value) || 1,
                    checkedOptions,
                    removedOptions,
                    meal: item.id,
                    mealNote: "",
                    optPrice: getOptionsPrice(),
                    portion: portion || null,
                    total: parseFloat(item.paketPrice ?? item.price),
                },
            ]);
        }
        note.current.value = "";
        setCheckedOptions([]);
        setRemovedOptions([]);
        setPortion(undefined);
    };

    const sepettenCikar = (item) => {

        if (cart?.length > 0) {
            let new_items = [...cart];

            if (item.quantity == 1) {
                setCart(cart.filter((c) => c.id != item.id));
            } else {
                new_items.forEach((it, i, new_items) => {
                    if (item.id == it.id) {
                        new_items[i].quantity--;
                    }
                });
                setCart(new_items);
            }
        }
    };
    const calculateToplam = () => {
        let total = 0.0;
        cart?.map((c) => {
            total += (parseFloat(c.total) + parseFloat(c.optPrice)) * c.quantity;
        });

        return total.toFixed(2) + " TL";
    };
    const giveOrder = (e) => {

        if (calculateToplam() == "0 TL") {
            toast.error("Ürün yok.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }

        if (selectedAddress == null) {
            toast.error("Adres Seçiniz", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }

        if (paymentMethod == null || paymentMethod == "") {
            toast.error("Ödeme Yöntemi Seçiniz", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }
        setButtonDisabled(true);
        var today = new Date();
        let id = uuid();
        let toAdd = {
            id,
            cart,
            total: calculateToplamSepet(),
            note: note.current.value,
            status: 0,
            noNotification: true,
            day: today.toLocaleDateString("en-US"),
        };
        toAdd.address = selectedAddress.title + " " + selectedAddress.address;
        toAdd.phone = number;
        toAdd.arama = true;
        toAdd.date = new Date();
        toAdd.note = notRef.current.value ?? "";
        toAdd.name = (user.name || nameRef.current?.value) ?? "";
        toAdd.paymentMethod = paymentMethod;
        toAdd.cafe = cafe;
        firestore.collection(`Restaurants/${cafe}/paket-orders`).doc(id).set(toAdd)
            .then(() => {
                cleanSepet();
                setButtonDisabled(false);
                window.open("about:blank", "_self");
                window.close();
            })



    };

    const cleanSepet = () => {
        setCart([]);
    };


    const calculateToplamSepet = () => {
        let total = 0.0;
        cart?.map((c) => {
            total += (parseFloat(c.total) + parseFloat(c.optPrice)) * c.quantity;
        });
        return total.toFixed(2);
    };
    const saveAddress = () => {
        var address = {};
        address.title = addressTitleRef.current.value;
        address.address = addressRef.current.value;

        var ref = firestore
            .collection(`Restaurants/${cafe}/users`)
            .doc(number);

        ref.get()
            .then(doc => {
                if (doc.exists) {
                    return doc.data();
                }
                return {};
            }).then(data => {
                if (!data.addressList) {
                    data.addressList = [];
                    data.addressList.push(address);
                }
                else {
                    data.addressList.push(address);
                }
                data.name = nameRef.current.value;
                ref.set(data);
                setUser(data);
                setSelectedAddress(address);
                setAddNew(false);
            });
    }

    const removeAddress = async (address, index) => {
        const addressName = address.title || "Adres";
        if (!window.confirm(`“${addressName}” adresini silmek istediğinize emin misiniz?`)) {
            return;
        }

        setDeletingAddress(index);
        try {
            const updatedUser = await deleteCustomerAddress(cafe, number, address);
            setUser(updatedUser);
            if (selectedAddress === address) setSelectedAddress(undefined);
            toast.success("Adres silindi.", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
            });
        } catch (error) {
            toast.error(error.message || "Adres silinirken bir hata oluştu.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: true,
            });
        } finally {
            setDeletingAddress(null);
        }
    };
    const [openOptions, setOpenOptions] = useState();
    const [checkedOptions, setCheckedOptions] = useState([]);
    const [removedOptions, setRemovedOptions] = useState([]);
    const [portion, setPortion] = useState();

    const getPrice = (a) => {
        if (!a) return 0;
        if (a.paketPrice == null || a.paketPrice == "") {
            return parseFloat(a.price) || 0;
        }
        return parseFloat(a.paketPrice) || 0;
    };
    const getOptionsPrice = () => {
        let totalOpt = 0.0;
        checkedOptions.map((opt) => {
            totalOpt += parseFloat(getPrice(opt)) || 0;
        });
        return totalOpt;
    };

    const [addNew, setAddNew] = useState(false);
    const goBack = () => {
        history.push("/admin");
    };
    const [blurScreen, setBlurScreen] = useState(false);

    const [openMenu, setOpenMenu] = useState();

    const openOptionsMenu = () => {
        setOpenMenu("optionsMenu");
        setBlurScreen(true);
    };

    const paketMenu = useMemo(
        () =>
            (menu || []).map((category) => ({
                ...category,
                items: (category.items || []).map((item) => ({
                    ...item,
                    price: item.paketPrice ?? item.price,
                })),
            })),
        [menu]
    );

    const selectProduct = (item) => {
        if (
            item.addOptions?.length > 0 ||
            item.removeOptions?.length > 0 ||
            item.portions?.length > 0 ||
            item.showInMenu
        ) {
            setOpenOptions(item);
            openOptionsMenu();
            return;
        }
        sepeteEkle(item);
    };

    const printRef = useRef();
    const [orderToPrint, setOrderToPrint] = useState(null);
    const printData = useReactToPrint({
        content: () => printRef.current,
        onAfterPrint: () => setOrderToPrint(null),
    });

    useEffect(() => {
        if (orderToPrint) {
            printData();
        }
    }, [orderToPrint]);

    return (
        <>

            <div>
                <button type="button" className="pos-back-button" onClick={goBack}>
                    <i
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                        style={{ width: "2vw" }}
                    ></i>
                </button>
            </div>
            <div
                className="blurred"
                style={{ display: blurScreen ? "block" : "none" }}
            ></div>

            {openMenu === "optionsMenu" && (
                <MealOptionsMenu
                    item={openOptions}
                    checkedOptions={checkedOptions}
                    removedOptions={removedOptions}
                    portion={portion}
                    priceRef={priceRef}
                    getOptionPrice={getPrice}
                    onCheckedOptionsChange={setCheckedOptions}
                    onRemovedOptionsChange={setRemovedOptions}
                    onPortionChange={setPortion}
                    onCustomPriceChange={(price) => setCheckedOptions([{
                        id: "0",
                        name: "",
                        price,
                        paketPrice: price,
                        sortOrder: 0,
                    }])}
                    onConfirm={() => {
                        sepeteEkle(openOptions);
                        setOpenMenu();
                        setBlurScreen(false);
                        setOpenOptions(null);
                        setRemovedOptions([]);
                        setPortion(undefined);
                    }}
                    onClose={() => {
                        setOpenOptions(null);
                        setOpenMenu();
                        setCheckedOptions([]);
                        setRemovedOptions([]);
                        setPortion(undefined);
                        setBlurScreen(false);
                    }}
                />
            )}

            <div className="pos-screen phone-order-screen">
                {(
                    <div className="pos">
                        <div className="content">
                            <div className="row">
                                <div className="phone-customer-panel">

                                    <>
                                        <div className="phone-customer-content">
                                            {user?.addressList != null && !addNew ? (
                                                <>
                                                    <div className="phone-customer-header">
                                                        <span className="phone-customer-icon"><FiUser /></span>
                                                        <div>
                                                            <span>Arayan müşteri</span>
                                                            <h2>{user?.name || "İsimsiz müşteri"}</h2>
                                                            <p>{number}</p>
                                                        </div>
                                                    </div>
                                                    <div className="phone-address-heading">
                                                        <span><FiMapPin /> Kayıtlı adresler</span>
                                                        <strong>{user.addressList.length}</strong>
                                                    </div>
                                                    <div className="phone-address-list">
                                                        {user?.addressList.map((address, i) => (
                                                            <div className={`phone-address-card ${selectedAddress === address ? "is-selected" : ""}`} key={`${address.title}-${i}`}
                                                                onClick={() => {
                                                                    setSelectedAddress(address);
                                                                }}>
                                                                <div className="phone-address-copy">
                                                                    <h5>{address.title !== "" ? address.title : "Adres"}</h5>
                                                                    <p>{address.address ?? address.addres}</p>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="phone-address-delete"
                                                                    aria-label={`${address.title || "Adres"} adresini sil`}
                                                                    disabled={deletingAddress === i}
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        removeAddress(address, i);
                                                                    }}
                                                                >
                                                                    <FiTrash2 />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <button type="button" onClick={() => {
                                                        setAddNew(true);
                                                    }} className="phone-add-address"><FiPlus /> Yeni adres ekle</button>
                                                </>
                                            ) : (
                                                <div className="phone-address-form">
                                                    <div className="phone-customer-header compact">
                                                        <span className="phone-customer-icon"><FiUser /></span>
                                                        <div><span>Yeni müşteri adresi</span><p>{number}</p></div>
                                                    </div>
                                                    <form onSubmit={(event) => event.preventDefault()}>
                                                        <div className="form-group">
                                                            <label htmlFor="phone-customer-name">İsim</label>
                                                            <input
                                                                id="phone-customer-name"
                                                                type="text"
                                                                className="form-control"
                                                                ref={nameRef}
                                                                defaultValue={addNew ? user?.name || "" : ""}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="phone-address-title">Adres başlığı</label>
                                                            <input
                                                                id="phone-address-title"
                                                                type="text"
                                                                className="form-control"
                                                                ref={addressTitleRef}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="phone-address-detail">Adres</label>
                                                            <textarea
                                                                id="phone-address-detail"
                                                                className="form-control"
                                                                ref={addressRef}
                                                            />
                                                        </div>
                                                        <div className="phone-address-form-actions">
                                                            <button type="button" className="phone-save-address" onClick={saveAddress}>
                                                                Kaydet
                                                            </button>
                                                            {addNew && (<button
                                                                type="button"
                                                                className="phone-cancel-address"
                                                                onClick={() => {
                                                                    setAddNew(false);
                                                                }}
                                                            >
                                                                İptal
                                                            </button>)}
                                                        </div>
                                                    </form>
                                                </div>
                                            )}
                                        </div>
                                        <div className="phone-order-details">
                                            <span className="phone-section-label">Ödeme yöntemi</span>
                                            <ButtonGroup className="phone-payment-methods">
                                                {(info?.paymentMethods || Object.values(PaymentMethod)).map(method => (
                                                    <Button key={method} variant={paymentMethod === method ? "success" : "light"}
                                                        className={paymentMethod === method ? "is-selected" : ""}
                                                        onClick={() => setPaymentMethod(method)}>{method}</Button>)
                                                )}
                                            </ButtonGroup>
                                            <div className="phone-order-note">
                                                <label htmlFor="phone-order-note">Sipariş notu</label>
                                                <textarea
                                                    id="phone-order-note"
                                                    placeholder="Kurye veya mutfak için not ekleyin..."
                                                    ref={notRef}>
                                                </textarea>
                                            </div>
                                        </div>

                                        <button
                                            className="phone-complete-order"
                                            disabled={buttonDisabled}
                                            onClick={() => {
                                                if (cart?.length > 0) giveOrder();
                                                select(null);
                                                setOpenOptions(false);
                                                setCheckedOptions([]);
                                                setPaymentMethod();
                                            }}
                                        >

                                            <FaPowerOff /> Siparişi tamamla
                                        </button>
                                    </>

                                </div>
                                <div className="phone-cart-panel">
                                    {/*<div className="not-ekle">
                  <p>Not Ekle</p>""
                  <div className="input-group" id="meal-note">
                    <textarea
                      className="form-control"
                      aria-label="With textarea"
                      ref={note}
                      style={{
                        borderRadius: 10,
                        height: "3%",
                      }}
                    ></textarea>
                  </div>
                    </div>*/}

                                    <p className="phone-cart-title">
                                        Adisyon
                                    </p>
                                    <ul className="list-group adisyon">
                                        {cart &&
                                            cart?.length > 0 &&
                                            cart?.map((s) => (
                                                <li
                                                    className="list-group-item phone-cart-item"
                                                    onClick={() => {
                                                        sepettenCikar(s);
                                                    }}
                                                >
                                                    <div className="row">
                                                        <div className="col-10">
                                                            <span>
                                                                {s.quantity} x
                                                                {(s.portion != null ? s.portion.name : " ") +
                                                                    " " +
                                                                    menuObj[s.meal].name}
                                                            </span>
                                                            <p className="phone-cart-options">
                                                                {s.checkedOptions &&
                                                                    s.checkedOptions
                                                                        .map((opt) => opt.name)
                                                                        .join(",")}
                                                            </p>
                                                            {s.removedOptions?.length > 0 && (
                                                                <p className="phone-cart-options is-removed">
                                                                    Çıkarılacak: {s.removedOptions.map((opt) => opt.name).join(", ")}
                                                                </p>
                                                            )}
                                                        </div>
                                                        <div className="col-2">
                                                            <span className="phone-cart-price">
                                                                {(parseFloat(s.total) + parseFloat(s.optPrice)) * s.quantity} TL
                                                            </span>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        {cart.length > 0 && (
                                            <p className="phone-cart-subtotal">
                                                Sepet Toplam: {calculateToplamSepet()} ₺
                                            </p>
                                        )}
                                    </ul>

                                    <div className="phone-cart-footer">
                                        <p>
                                            Toplam: <span>{calculateToplamSepet()} ₺</span>
                                        </p>
                                    </div>
                                </div>
                                <ProductCatalog
                                    menu={paketMenu}
                                    selectedCategory={posSelected}
                                    selectedOptionsItem={openOptions}
                                    quantityInputRef={note}
                                    onCategorySelect={posSelect}
                                    onProductSelect={selectProduct}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Arama;
